export enum PriceListItemMode {
  All = "all",
  Any = "any",
  Group = "group",
}
